export function societyRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SOCIETY_START":           
        case "UPDATE_SOCIETY_START":                                 
        case "DELETE_SOCIETY_START":                                 
        case "FETCH_SOCIETY_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_SOCIETY_FULFILLED":           
        case "UPDATE_SOCIETY_FULFILLED":                                 
        case "DELETE_SOCIETY_FULFILLED":                                 
        case "FETCH_SOCIETY_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_SOCIETY_ERROR":
        case "UPDATE_SOCIETY_ERROR":
        case "DELETE_SOCIETY_ERROR":
        case "FETCH_SOCIETY_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}